import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import useGetMerchantUsers from "@/services/merchantUser/hooks/useGetMerchantUsers";
import { Card, Stack } from "@mantine/core";
import TeamItem from "./TeamItem";
import { MerchantUserDto } from "@/models/club";


type Props = {
    setSelectedTeam: (user: MerchantUserDto) => void;
    close: () => void;
}

export default function SelectTeam({ setSelectedTeam, close }: Props) {
    const { data, isLoading } = useGetMerchantUsers();
    return (
        <Stack gap="xs">
            {isLoading && <ListItemLoading count={4} />}
            {data?.map((user) => (
                <>
                    <Card withBorder p="md" radius="md" onClick={() => {
                        setSelectedTeam(user);
                        close();
                    }}>
                        <TeamItem key={user.id} user={user} />
                    </Card>
                </>
            ))}
        </Stack>
    )
}
